// extracted by mini-css-extract-plugin
module.exports = {"link":"SocialItem_link__1XDiY","icon":"SocialItem_icon__1ypoI"};